import { orchestrator } from 'satcheljs';
import selectFolder from '../actions/selectFolder';
import onSelectFolder from 'owa-mail-store/lib/actions/selectFolder';

orchestrator(onSelectFolder, actionMessage => {
    const { folderId, treeType, actionSource } = actionMessage;
    selectFolder(folderId, treeType, actionSource);
});
